import React from 'react'
import * as Aicons from "react-icons/ai"
import * as Bsicons from "react-icons/bs";

export const NavbarData = [
    {
        title: "Home",
        path: "/",
        icon: <Aicons.AiFillHome />
    },
    {
        title: "Clips",
        path: "/Clips",
        icon: <Bsicons.BsFillPlayBtnFill />
    },
    // {
    //     title: "Discord",
    //     path: "/Discord",
    //     icon: <Faicons.FaDiscord />
    // },
    // {
    //     title: "Banner Creator",
    //     path: "/BannerCreator",
    //     icon: <Bsicons.BsImages />
    // },
    // {
    //     title: "Add Listing",
    //     path: "/Insert",
    //     icon: <Aicons.AiOutlinePlusCircle />
    // },
    // {
    //     title: "Job Listings",
    //     path: "/Jobs",
    //     icon: <Aicons.AiFillContainer />
    // },
    // {
    //     title: "Dictionary",
    //     path: "/Dictionary",
    //     icon: <Faicons.FaBookDead />
    // }
]
